import React, {Component} from 'react';
import {TimelineMax, TweenMax, Power2} from 'gsap'

import Background from '../common/Background'


import homeBG from '../../assets/images/home/home-bg.jpg'
import HomeArtwork from './HomeArtwork'


class Home extends Component {


    componentWillEnter(callback) {
        const el = this.container;
        console.log(el, "home")
        TweenMax.fromTo(el, 0.3, {y: 100, opacity: 0}, {y: 0, opacity: 1, onComplete: callback})
    }

    componentWillLeave(callback) {
        const el = this.container;
        console.log(el, "home")
        TweenMax.fromTo(el, 0.3, {y: 0, opacity: 1}, {y: -100, opacity: 0, onComplete: callback})
    }


    componentDidMount() {


        console.log(window.innerWidth)

        if (window.innerWidth > 768) {
            // Setting Up Objects
            const image = document.getElementsByClassName('image-holder')
            const artwork = document.getElementsByClassName('artwork')
            const headingSmall = document.getElementsByClassName('small')
            const heading = document.getElementsByClassName('content')
            const greenBar = document.getElementsByClassName('green-bar')

            let htl = new TimelineMax()

            //setter
            htl.set(image, {scale: 1, opacity: 0})
            htl.set(artwork, {opacity: 0})
            htl.set(headingSmall, {x: '-250', opacity: 0})
            htl.set(heading, {x: '50', opacity: 0})
            htl.set(greenBar, {width: '0'})

            //animation
            htl.to(image, 2.5,
                {
                    scale: 1,
                    opacity: 1,
                    force3D: false,
                    ease: Power2.easeOut
                })
                .to(heading, 1, {
                    x: 0,
                    opacity: 1,
                    force3D: false,
                    ease: Power2.easeOut
                }, '-=.7')
                .to(headingSmall, 1, {
                    x: 0,
                    opacity: 1,
                    force3D: false,
                    ease: Power2.easeOut
                }, '-=1.3')
                .to(greenBar, 1.2, {
                    transformOrigin: "100% 50%",
                    width: '37vw',
                    force3D: false,
                    ease: Power2.easeInOut
                }, '-=1.5')
                .to(artwork, 1.5, {
                    opacity: .35,
                    ease: Power2.easeInOut
                }, '-=.7');

        }
    }


    render() {
        return (
                <div id="home" className="container" ref={c => this.container = c}>
                    <div className="image-holder">
                        <Background src={homeBG}/>
                    </div>
                    <div className="artwork">
                        <HomeArtwork/>
                    </div>
                    <div className="green-bar"></div>
                    <h1 className="content">
                        <small className="small">Where <span>Innovation</span> Leads</small>
                        To A <span>Successful</span> Change
                    </h1>
                </div>
        )
    }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Pages/Home.js